export enum AppVersionServiceKeys {
  GET_APP_VERSION_CONFIG = 'GET_APP_VERSION_CONFIG',
}
